import { useState } from 'react';
import { CSSTransition, SwitchTransition } from 'react-transition-group';
import { useEffectOnce } from 'react-use';
import exit from '~/assets/icons/exit.svg';
import group from '~/assets/icons/group_2.svg';
import { Text } from '~/components/ui/Text';
import { Apps } from '~/shared';
import truckJobIcon from '../../assets/icons/apps/truck_job.svg';
import {
	resetTruckJobSlice,
	returnToLauncher,
	setActiveMenu,
	useLayoutDispatch,
	useLayoutSelector,
} from '../../redux';
import { AppTruckJobAllOrders } from '../AppTruckJobAllOrders';
import { AppTruckJobMyGroup } from '../AppTruckJobMyGroup';
import { AppTruckJobMyOrders } from '../AppTruckJobMyOrders';
import { AppTruckJobMyProgress } from '../AppTruckJobMyProgress';
import { AppTruckJobUnavailable } from '../AppTruckJobUnavailable';
import { LoadingScreenNew } from '../LoadingScreenNew';
import { getAppLoadingInfo } from '../TabletApp/TabletApp.model';
import { AppTruckJobMenu, appTruckJobButtons } from './AppTruckJob.model';
import {
	StyledAppTitleContainer,
	StyledContainer,
	StyledExitButton,
	StyledGroupItem,
	StyledLayoutContainer,
	StyledLeftContainer,
	StyledMenuBottom,
	StyledMenuContainer,
	StyledMenuItem,
	StyledMenuTop,
	StyledWrapper,
} from './AppTruckJob.styled';

const AppTruckJob = () => {
	const dispatch = useLayoutDispatch();
	const activeMenu = useLayoutSelector((state) => state.truckJob.activeMenu);
	const [loading, setLoading] = useState(true);
	const loadingInfo = getAppLoadingInfo(Apps.TruckJob);
	const unavailable = false;

	useEffectOnce(() => {
		setTimeout(() => {
			setLoading(false);
		}, 1000);

		return () => {
			dispatch(resetTruckJobSlice());
		};
	});

	return (
		<StyledWrapper>
			<SwitchTransition>
				<CSSTransition
					timeout={300}
					key={loading ? 0 : 1}
					classNames={'loading'}
					addEndListener={(node, done) =>
						node.addEventListener('transitionend', done, false)
					}
				>
					{loading ? (
						<LoadingScreenNew
							icon={loadingInfo.loadingIcon}
							text={loadingInfo.loadingMessage}
							color={'#1AB248'}
						/>
					) : (
						<StyledContainer>
							{unavailable ? (
								<AppTruckJobUnavailable />
							) : (
								<StyledLayoutContainer $compact>
									<StyledLeftContainer>
										<StyledMenuTop>
											<StyledAppTitleContainer>
												<img src={truckJobIcon} />
												<div>
													<Text className={'title'}>SDEK POST</Text>
													<Text className={'text'}>Доставляем быстро!</Text>
												</div>
											</StyledAppTitleContainer>
											<StyledMenuContainer>
												{Object.values(AppTruckJobMenu)
													.filter((item) => item !== AppTruckJobMenu.GROUP)
													.map((item) => (
														<StyledMenuItem
															key={item}
															$active={activeMenu === item}
															onClick={() => dispatch(setActiveMenu(item))}
														>
															<img src={appTruckJobButtons[item].icon} />
															<Text>{appTruckJobButtons[item].name}</Text>
														</StyledMenuItem>
													))}
											</StyledMenuContainer>
										</StyledMenuTop>
										<StyledMenuBottom>
											<StyledGroupItem
												$active={activeMenu === AppTruckJobMenu.GROUP}
												onClick={() =>
													dispatch(setActiveMenu(AppTruckJobMenu.GROUP))
												}
											>
												<img src={group} />
												<Text>Мой конвой</Text>
											</StyledGroupItem>
											<StyledMenuContainer>
												<StyledExitButton
													onClick={() => dispatch(returnToLauncher())}
												>
													<img src={exit} />
													<Text>Выйти из приложения</Text>
												</StyledExitButton>
											</StyledMenuContainer>
										</StyledMenuBottom>
									</StyledLeftContainer>
									<div>
										{activeMenu === AppTruckJobMenu.ALL_ORDERS && (
											<AppTruckJobAllOrders />
										)}
										{activeMenu === AppTruckJobMenu.MY_CONTRACTS && (
											<AppTruckJobMyOrders />
										)}
										{activeMenu === AppTruckJobMenu.PROGRESS && (
											<AppTruckJobMyProgress />
										)}
										{activeMenu === AppTruckJobMenu.GROUP && (
											<AppTruckJobMyGroup />
										)}
									</div>
								</StyledLayoutContainer>
							)}
						</StyledContainer>
					)}
				</CSSTransition>
			</SwitchTransition>
		</StyledWrapper>
	);
};

export { AppTruckJob };
